<template>
    <div v-if="initDone" class="column is-four-fifths">
        <div class="mb-3">
            <p class="mb-2">{{ translate("notification_center.events.title") }}</p>
            <p class="mb-3">
                <QueryInput v-model="query" />
            </p>
        </div>
        <div>
            <div class="is-sticky-position p-5">
                <div class="has-text-centered is-size-5">
                    <p class="mb-2">{{ translate("notification_center.events.number_of_your_selected_receivers") }}</p>

                    <ReceiversSummary :emails="calculatedEmails" :phones="calculatedPhones" :users="calculatedUserIds" />
                </div>
            </div>

            <h6 class="has-text-weight-bold is-size-6 mb-3 has-border">
                {{ translate("page.events.incoming") }}
            </h6>

            <template v-if="filteredIncoming.length > 0">
                <SourceEvent v-for="sourceEvent in filteredIncoming" :key="sourceEvent.id" :source-event="sourceEvent" />
            </template>

            <p v-else class="has-text-centered has-text-info">
                {{ translate("page.events.no_events") }}
            </p>

            <h6 class="has-text-weight-bold is-size-6 mb-3 has-border">
                {{ translate("page.events.archive") }}
            </h6>

            <template v-if="filteredArchived.length > 0">
                <SourceEvent v-for="sourceEvent in filteredArchived" :key="sourceEvent.id" :source-event="sourceEvent" />
            </template>
            <p v-else class="has-text-centered has-text-info">
                {{ translate("page.events.no_events") }}
            </p>
        </div>
    </div>
    <div v-else class="column">
        <div class="columns is-centered">
            <LoadingSpinner2 class="has-added-margin" />
        </div>
    </div>
</template>

<script>
    import apiMixin from "../../Api/apiMixin";
    import SourceEvent from "./SourceEvent";
    import objectMatcher from "../../Common/objectMatcher";
    import QueryInput from "../../Common/QueryInput";
    import LoadingSpinner2 from "../../Common/LoadingSpinner2";
    import { mapState } from "vuex";
    import ReceiversSummary from "./ReceiversSummary";
    import translatorMixin from "../../Common/translatorMixin";
    import errorHandlerMixin from "../../Common/errorHandlerMixin";

    export default {
        name: "choose-source-events-step",
        components: { ReceiversSummary, LoadingSpinner2, QueryInput, SourceEvent },
        mixins: [apiMixin, translatorMixin, errorHandlerMixin],
        data() {
            return {
                initDone: false,
                query: "",
                sourceEvents: { incoming: [], archived: [] },
            };
        },
        computed: {
            ...mapState("choosingSourceEvents", ["calculatedEmails", "calculatedPhones", "calculatedUserIds"]),
            filteredIncoming() {
                return this.sourceEvents.incoming.filter(event => objectMatcher.matchBySearchQuery(event, this.query));
            },
            filteredArchived() {
                return this.sourceEvents.archived.filter(event => objectMatcher.matchBySearchQuery(event, this.query));
            },
        },
        mounted() {
            return this.getSourceEvents()
                .then(sourceEvents => (this.sourceEvents = sourceEvents))
                .catch(this.handleError)
                .finally(() => {
                    this.initDone = true;
                });
        },
        methods: {
            getSourceEvents() {
                return this.notificationsCenterApi().getSourceEvents();
            },
        },
    };
</script>

<style scoped></style>
